import * as yup from 'yup';

export const BookFormValidation = yup.object().shape({
    idCategory: yup.string().required('Campo é obrigatória'),
    title: yup.string().required('Campo é obrigatória'),
    copies: yup.number().typeError("Apenas numeros").required('Campo é obrigatória'),
});